import { Injectable } from "@angular/core";
import { GetMarketingMessageWS } from "@app/core/marketing/data/network/get-marketing-message.ws";
import { GetAllMessagesAndBannersWS } from "@app/core/marketing/data/network/get-all-messages-and-banners.ws";
import { MarketingMessage } from "@app/core/marketing/domain/marketing-message";
import { MarketingMessageRepo } from "@app/core/marketing/domain/marketing-message.repo";
import { Observable, catchError, map } from "rxjs";
import { DismissMarketingMessageWS } from "../network/dismiss-marketing-message.ws";

@Injectable()
export class MarketingMessageRepoImpl implements MarketingMessageRepo {
  constructor(
    private getMarketingMessageWS: GetMarketingMessageWS,
    private getAllMessagesAndBannersWS: GetAllMessagesAndBannersWS,
    private dismissMarketingMessageWS: DismissMarketingMessageWS
  ) {}

  getMarketingMessage(token: string): Observable<MarketingMessage> {
    return this.getMarketingMessageWS.execute(token);
  }

  getAllMessagesAndBanners(token: string): Observable<MarketingMessage[]> {
    return this.getAllMessagesAndBannersWS.execute(token).pipe(
      catchError(() =>
        this.getMarketingMessageWS
          .execute(token)
          .pipe(map((banner) => (banner.show ? [banner] : [])))
      )
    );
  }

  dismissMarketingMessage(token: string, id: string, type: 'personal' | 'marketing'): Observable<void> {
    return this.dismissMarketingMessageWS.execute(
      token,
      id,
      type
    );
  }
}
